<template>
  <div class="event-page container">
    <template v-if="data.data">
      <div class="row">
        <print-button/>
      </div>
      <div class="row title-container">
        <H2 class="mt-3 pl-3">{{ data.title && data.title.rendered}}</H2>
      </div>
      <div class="row d-flex justify-content-start align-items-start text-left">
        <div class="col-12 mb-3 mt-3" v-if="data.data.main_image">
          <img class="main_image" :src="data.data.main_image" alt="メイン画像">
        </div>
        <div class="col-12">
          <div class="main_content" v-html="data.content.rendered"></div>
        </div>
        <div class="col-12 pt-5">
          <dl class="row text-left datalist" v-if="data.data.open_periods">
            <dt class="col-md-2">開催期間</dt>
            <dd class="col-md-10">{{data.data.open_periods}}</dd>
          </dl>
          <dl class="row text-left datalist" v-if="data.data.open_times">
            <dt class="col-md-2">開催時間</dt>
            <dd class="col-md-10">{{data.data.open_times}}</dd>
          </dl>
          <dl class="row text-left datalist" v-if="data.data.address">
            <dt class="col-md-2">開催地</dt>
            <dd class="col-md-10">{{data.data.address}}</dd>
          </dl>
          <dl class="row text-left datalist" v-if="data.data.tel">
            <dt class="col-md-2">電話</dt>
            <dd class="col-md-10">{{data.data.tel}}</dd>
          </dl>
          <dl class="row text-left datalist" v-if="data.data.fax">
            <dt class="col-md-2">FAX</dt>
            <dd class="col-md-10">{{data.data.fax}}</dd>
          </dl>
          <dl class="row text-left datalist" v-if="data.data.access">
            <dt class="col-md-2">アクセス</dt>
            <dd class="col-md-10">{{data.data.access}}</dd>
          </dl>
          <dl class="row text-left datalist" v-if="data.data.contact">
            <dt class="col-md-2">お問い合わせ先</dt>
            <dd class="col-md-10">{{data.data.contact}}</dd>
          </dl>
          <dl class="row text-left datalist" v-if="data.data.site">
            <dt class="col-md-2">ホームページ</dt>
            <dd class="col-md-10">
              <a :href="data.data.site" target="_blank">{{data.data.site}}</a>
            </dd>
          </dl>
          <dl class="row text-left datalist" v-if="data.data.description">
            <dt class="col-md-2">備考</dt>
            <dd class="col-md-10">{{data.data.description}}</dd>
          </dl>
          <div class="row" v-if="mapInfo && mapInfo.markers">
            <div class="col-12 col-lg-8">
              <map-view
                class="map-container"
                :center="mapInfo.center"
                :zoom="mapInfo.scale"
                :markers="mapInfo.markers"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="loading" v-else>Loading....</div>
  </div>
</template>

<script>
import WpClient from "../wpClient.js";
import PrintButton from "@/components/PrintButton";
import MapView from "@/components/MapView";
import utils from "@/utils";

export default {
  name: "EventPage",
  components: {
    PrintButton,
    MapView
  },
  props: {
    slug: String
  },
  data: function() {
    return {
      data: {}
    };
  },
  async mounted() {
    this.data = (await WpClient.getCalendarPost(this.slug))[0];
  },
  computed: {
    mapInfo() {
      if (!this.data.data.map_url) {
        return null;
      }

      const v = utils.convertMapUrlToLatLang(this.data.data.map_url);
      return v;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.datalist {
  margin: 0;
  padding: 8px 0;
  border-bottom: rgb(238, 238, 238) 2px solid;
}
.datalist:first-child {
  border-top: rgb(238, 238, 238) 2px solid;
}

.right-arrow {
  margin-right: 1rem;
  height: 2rem;
  margin-bottom: 3px;
}

img.main_image {
  width: 85%;
}

@media only screen and (min-width: 992px) {
  img.main_image {
    object-fit: cover;
    width: 560px;
    height: 420px;
  }
}
@media only screen and (min-width: 1200px) {
  img.main_image {
    width: 720px;
    height: 540px;
  }
}

.map-container {
  margin-top: 2rem;
  @media print {
    margin-top: 0.5rem;
  }
}

.col-md-2 {
  @media print {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 16.66667%;
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
}

.col-md-8 {
  @media print {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 83.33333%;
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }
}


.loading {
  height: 200vh;
}
</style>
<style lang="scss">
.event-page {
  .map-container,
  .map-view,
  .map {
    height: 600px;
    page-break-inside: avoid;

    @media print {

    }

    /* // 中デバイス（タブレット, 768px 以上） */
    @media (min-width: 768px) {
      height: 400px;
    }

    /* // 大デバイス（デスクトップ, 992px 以上） */
    @media (min-width: 992px) {
      height: 525px;
    }

    /* // 特大デバイス（ワイド・デスクトップ, 1200px 以上） */
    @media (min-width: 1200px) {
      height: 640px;
    }
  }
}
</style>
